import { Button, Form, List } from "devextreme-react";
import { GroupItem, Item, Label } from "devextreme-react/cjs/form";
import React, { useState } from "react";

export default function MyForm() {

  const [i, seti] = useState(1)

  const handleItemClick = (e) => {
    console.log(e)
    seti(i + 1)
  }

  const handleValueChanged = (e) => {
    seti(i + 1)
  }

  return (
    <React.Fragment>
      <div className={'content-block'} >
        <div className={'dx-card responsive-paddings'}>

          {` adım ${i}`}
          <Form width={500}>
            <GroupItem caption="İzin Türünü Seçiniz" visible={i == 1}>

              <List items={[
                "Yıllık İzin",
                "Mazeret izni",
                "Özel İzin"
              ]}
                onItemClick={handleItemClick}
              >

              </List>
            </GroupItem>
            <GroupItem caption="İzin Tarihini Giriniz" visible={i == 2}>

              <Item dataField="tarih" editorType="dxDateRangeBox"
                editorOptions={{
                  applyValueMode: "useButtons",
                  onValueChanged: handleValueChanged
                }}>

              </Item>
            </GroupItem>
            <GroupItem caption="Diğer" visible={i == 3}>
              <Item dataField="aciklama" editorType="dxTextArea" />
              <Item dataField="yerine_bakacak" editorType="dxSelectBox" />
            </GroupItem>
          </Form>
          <Button text="Geri" visible={i>1} onClick={() => {
            if (i > 1)
              seti(i - 1)
          }}></Button>
          <Button text="İleri" visible={i<3} onClick={() => {
            if (i < 3)
              seti(i + 1)
          }} ></Button>
          <Button text="Kaydet" visible={i==3} onClick={() => {
            
          }} ></Button>

        </div>
      </div>
    </React.Fragment>
  );
}


export function IzinTalep1() {

  return (
    <React.Fragment>
      <div className={'content-block'} >
        <div className={'dx-card responsive-paddings'}>

          <Form width={500}>
            <Item dataField="izin_turu" editorType="dxSelectBox" editorOptions={
              { items: ["Yıllık İzin", "Mazeret İzni", "Ücretsiz İzin"] }
            }></Item>
            <Item dataField="izin_tarihi" editorType="dxDateRangeBox" />
            <Item dataField="aciklama" editorType="dxTextArea" />
            <Item dataField="yerine_bakacak" editorType="dxSelectBox" />
            <Item dataField="belge" />
            <GroupItem>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button text="Kaydet" style={{ margine: "0" }} ></Button>
              </div>
            </GroupItem>

          </Form>


        </div>
      </div>
    </React.Fragment>
  );
}